import type { Fallacy } from "./types";
import { createStory } from "./types";

export const ikeaEffect: Fallacy = {
    id: "ikea-effect",
    name: "IKEA Effect",
    emoji: "🔨",
    category: "Otak yang Menipu Diri",
    description: "Menilai sesuatu **lebih tinggi** hanya karena **kita yang membuatnya sendiri**, terlepas dari kualitas objektifnya.",
    tldr: "Rak rakitan sendiri serasa karya seni, padahal miring — ya itu IKEA Effect.",
    detail: "IKEA Effect adalah bias kognitif di mana orang **memberikan nilai yang jauh lebih tinggi** pada sesuatu yang mereka buat sendiri — bahkan jika kualitasnya lebih rendah. Nama bias ini berasal dari toko furnitur IKEA; penelitian menunjukkan orang yang merakit furnitur sendiri **menilai hasilnya setara dengan buatan profesional**.\n\nDi dunia bisnis, IKEA Effect bisa berbahaya. Tim yang sudah invest waktu dan energi ke suatu project sering **menolak feedback negatif** karena merasa \"ini anak gue.\" Ini bisa menyebabkan perusahaan terus menginvestasikan sumber daya ke produk yang seharusnya sudah di-kill.\n\nCara melawan: Minta **pendapat objektif dari orang luar** yang tidak terlibat dalam proses pembuatan. Pisahkan identitas kamu dari karya kamu.",
    story: createStory("IKEA Effect", "🔨", {
      hook: {
        title: "Pernah bikin sesuatu sendiri?",
        body: "Rasanya masterpiece kan? Padahal... coba tanya pendapat orang lain deh. 😬",
      },
      convo: {
        claim: "Startup aku udah 2 tahun jalan, user cuma 500 dan churn 60%. Tapi **produk aku bagus kok, aku yang design dari nol** soalnya.",
        response: "60% churn itu alarm keras. **Kamu overvalue karena ada emotional investment.**",
      },
      reveal: {
        body: "Kamu **menilai sesuatu lebih tinggi** cuma karena **kamu yang bikin sendiri**. Kayak furnitur IKEA yang dirakit sendiri — kerasa setara buatan profesional, padahal belum tentu.",
      },
      insight: {
        title: "Kenapa bahaya?",
        body: "Kamu jadi **nolak kritik** karena ngerasa \"ini anak aku.\" Padahal data dan feedback orang luar jauh lebih jujur dari perasaan sendiri.",
      },
      engagement: {
        title: "Pernah ngerasa karya sendiri terbaik padahal... biasa aja? 😅",
        body: "Masak, rakit furniture, atau nulis kode? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["sunk-cost", "dunning-kruger", "status-quo-bias", "loss-aversion"],
  };
